import React from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Oval } from "react-loader-spinner";
import LabelForm from "pages/signup/form/labelForm";
import UploadFile from "components/uploadFile";
import BGShutterstock from "images/auth/bg-shutterstock.png";
import { ReactComponent as TVendorIcon } from "images/auth/t-vendors.svg";
import { ReactComponent as ApprovedImage } from "images/externalPage/high-five.svg";
import { ReactComponent as AttachIcon } from "images/auth/attach.svg";
import useConfirmRequestPayment from "./useConfirmRequestPayment";
import useUploadFiles from "pages/signup/hooks/useUploadFiles";

const ConfirmRequestPayment = () => {
  const [t] = useTranslation();

  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm();

  const {
    isUploading,
    uploadInvoice,
    removeInvoice,
    invoiceRef,
    invoiceFileName,
  } = useUploadFiles({});

  const { onSubmit, navigate, isLoading, isAgency, successMsg, poNumber } =
    useConfirmRequestPayment();

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div
        className="w-full h-[100px] bg-no-repeat  bg-cover bg-center flex items-center px-[20%] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] fixed z-[999999999]"
        style={{
          backgroundImage: `url(${BGShutterstock})`,
          zIndex: 100,
        }}
      >
        <div className="max-w-[843px] w-full flex items-center justify-between">
          <TVendorIcon
            onClick={() => navigate("/login")}
            className="cursor-pointer"
          />
        </div>
      </div>

      {!successMsg ? (
        <div className="mt-[220px] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] flex flex-col mb-[97px] relative min-h-[calc(100vh-750px)] items-center justify-center">
          <LabelForm
            label={t("requestPayment")}
            labelClassName="text-primary font-bold text-[28px] md-max:text-[20px] not-italic mb-[30px] text-center"
          />

          <LabelForm
            label={t("requestPaymentMsg", { poNumber })}
            labelClassName="text-primary font-bold text-[20px] md-max:text-[16px] not-italic"
          />

          {isAgency === "true" ? (
            <UploadFile
              name={"invoice"}
              label={t("uploadInvoice")}
              register={register}
              registerArgs={{
                required: invoiceFileName
                  ? false
                  : t("errorField", { field: t("invoice") }),
              }}
              isRequired={true}
              placeHolderLabel={t("attachYourFiles") + ", " + t("maxSize")}
              icon={<AttachIcon />}
              isUploading={isUploading.certifications}
              isMultiFile={true}
              getFile={(e, isDrag) => uploadInvoice(e, isDrag, setValue)}
              fileName={invoiceFileName}
              ref={invoiceRef}
              onRemoveFile={() => removeInvoice(setValue)}
              errorMessage={errors.invoice ? errors.invoice.message : ""}
              accept=".pdf,.doc,.docx,.xlsx"
              placeHolderContainerClassName={`flex p-[14px] justify-between items-center gap-[8px] self-stretch rounded-[6px] h-[54px] w-full min-w-[190px] sm-max:min-w-full sm-max:w-full border-[1px] border-dashed ${
                errors.invoice && !invoiceFileName
                  ? "border-red"
                  : "border-dark-gray"
              } cursor-pointer`}
              labelClassName="text-primary font-semibold text-[20px] mt-[35px]"
              containerClassName="flex flex-col sm-max:grid sm-max:w-full gap-[10px] w-[512px]"
            />
          ) : (
            <></>
          )}

          <div className="flex items-end justify-end gap-[10px] mt-[40px]">
            <button
              type="submit"
              disabled={isLoading || (!invoiceFileName && isAgency === "true")}
              className={`flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-primary bg-primary h-[46px] w-[150px] ${
                isLoading || (!invoiceFileName && isAgency === "true")
                  ? "cursor-not-allowed"
                  : "cursor-pointer"
              }`}
            >
              <Oval
                height={30}
                width={30}
                color="#FFF"
                visible={isLoading}
                ariaLabel="oval-loading"
                secondaryColor="#FFF"
                strokeWidth={5}
                strokeWidthSecondary={3}
              />
              <div className="text-white font-bold text-[18px] not-italic">
                {t("confirm")}
              </div>
            </button>
          </div>
        </div>
      ) : (
        <div className="mt-[220px] px-[10%] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] flex flex-col mb-[97px] relative min-h-[calc(100vh-750px)] items-center justify-center">
          <ApprovedImage />
          <LabelForm
            label={t(successMsg)}
            labelClassName="text-primary font-bold text-[22px] md-max:text-[18px] not-italic ml-[15px]"
          />
        </div>
      )}
    </form>
  );
};

export default ConfirmRequestPayment;
